import _ from "lodash";
import React, { useState } from "react";
import {
  IonModal,
  IonIcon,
  IonAlert,
  IonHeader,
  IonToolbar,
  IonContent,
} from "@ionic/react";
import { closeOutline, trashOutline } from "ionicons/icons";
import ReactImageAppear from "react-image-appear";

import AppStateDisplay from "../app-state-display";

import styled from "styled-components";
const Modal = styled(IonModal)`
  --background: #666666 !important;
`;
const ModalContent = styled(IonContent)`
  --background: #666666;
`;
const CloseIcon = styled(IonIcon)`
  color: #ffffff;
  font-size: 2em;
`;

const DeleteIcon = styled(IonIcon)`
  color: #eb445a;
  font-size: 2em;
`;

const ImageContainer = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: center;
  padding: 0px 8px 8px 8px;
`;

const ExpandedPhotoModal = (props) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const imageSrc = _.get(props.photo, "image");

  return (
    <Modal {...props}>
      <ModalContent>
        <IonHeader>
          <IonToolbar color="primary">
            {props.addAndDeleteEnabled && (
              <DeleteIcon
                icon={trashOutline}
                onClick={() => {
                  setConfirmDelete(true);
                }}
                slot="end"
              />
            )}
            <CloseIcon
              icon={closeOutline}
              onClick={props.handleClose}
              slot="end"
            />
          </IonToolbar>
        </IonHeader>
        <AppStateDisplay>
          <ImageContainer>
            {imageSrc && (
              <ReactImageAppear
                src={imageSrc}
                animation="zoomIn"
                animationDuration="1s"
                placeholderStyle={{ background: "#666666" }}
              />
            )}
          </ImageContainer>
        </AppStateDisplay>
      </ModalContent>
      <IonAlert
        isOpen={confirmDelete}
        onDidDismiss={() => setConfirmDelete(false)}
        cssClass="my-custom-class"
        header={"Confirm Delete"}
        message={"Delete the following photo?"}
        buttons={[
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              // Do nothing
            },
          },
          {
            text: "OK",
            handler: () => {
              props.handleConfirmDelete(props.photo);
            },
          },
        ]}
      />
    </Modal>
  );
};
export default ExpandedPhotoModal;
